// extracted by mini-css-extract-plugin
export var closeButton = "_2i-1";
export var closeX = "_2i-3";
export var container = "_2i-0";
export var image = "_2i-2";